export const toastOncePerDay = (key, callback, hours = 24) => {
  const lastShown = localStorage.getItem(key);
  const now = Date.now();
  const limit = hours * 60 * 60 * 1000;

  if (!lastShown || now - Number(lastShown) > limit) {
    callback();
    localStorage.setItem(key, now.toString());
  }
};
